<template>
  <AppLazySelect
    ref="lazySelect"
    v-model="value"
    resource="member"
    :fetcher="fetcher"
    :loading="loading"
    :label="withinSidebar ? 'Member' : ''"
  >
    <template #single-result-leading="{ value }">
      <AppAvatar
        v-if="value.avatar"
        :avatar="value.avatar"
        size="speck"
      />
    </template>
    <template #item-leading="{ item: user }">
      <AppAvatar
        v-if="user.avatar"
        :avatar="user.avatar"
        size="speck"
      />
    </template>
  </AppLazySelect>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { TimeEntriesResource } from '~/resources';

export default {
  name: 'TimeEntriesMemberFilter',
  props: {
    withinSidebar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      user: 'user',
      loading: 'loading',
      organizationId: 'organization_id',
    }),
    value: {
      get() {
        return this.user;
      },
      set(user = null) {
        this.updateSearch({ filters: { user: user?.id ?? null } });
      },
    },
  },
  methods: {
    ...mapActions(['updateSearch']),
    fetcher(payload) {
      return TimeEntriesResource.members({ organization_id: this.organizationId }, payload, {
        abortReload: true,
      });
    },
  },
};
</script>
